import { LoadingContainer } from 'components/loadingContainer'
import { TicketBuying } from 'features/user/Ticket'
import { useEventByIdForSeats } from 'hooks/admin/useEvents'
import { useParams } from 'react-router-dom'

export const TicketBuyingPage = () => {
    const { eventId } = useParams<{ eventId?: string }>()
    const { data, isLoading, error } = useEventByIdForSeats(eventId || '')

    return (
        <>
            <meta name="robots" content="noindex, nofollow" />
            <LoadingContainer isLoading={isLoading} error={error}>
                {data && <TicketBuying currentEvent={data} />}
            </LoadingContainer>
        </>
    )
}
